import { render, staticRenderFns } from "./DashStudentApplication.vue?vue&type=template&id=770986ea&scoped=true&"
import script from "./DashStudentApplication.vue?vue&type=script&lang=js&"
export * from "./DashStudentApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770986ea",
  null
  
)

export default component.exports